module.exports = " <div class=yaml-fieldtype-wrapper> <span>YAML</span> <div class=editor v-el:codemirror></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/YamlFieldtype.vue
// module id = 779
// module chunks = 0